import React from 'react';
import PropTypes from 'prop-types';
import './LikeIcon.css';

function LikeIcon({ filled, name }) {
  return (
    <svg
      aria-labelledby="icon-heart-title"
      className="icon-heart"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="473 1321 18 17.134"
    >
      <title id="icon-heart-title">{name}</title>
      <path
        id="Path_3583"
        data-name="Path 3583"
        className={`inside-heart ${filled ? 'filled' : ''}`}
        d="M8,14.72,6.88,13.6C2.72,9.92,0,7.44,0,4.4A4.338,4.338,0,0,1,4.4,0,4.808,4.808,0,0,1,8,1.68,4.808,4.808,0,0,1,11.6,0,4.338,4.338,0,0,1,16,4.4c0,3.04-2.72,5.52-6.88,9.2Z"
        transform="translate(474 1322)"
      />
    </svg>
  );
}

LikeIcon.propTypes = {
  filled: PropTypes.bool,
  name: PropTypes.string
};

export default LikeIcon;



// WEBPACK FOOTER //
// ./src/components/Icon/LikeIcon/index.js